<template>
  <v-container>
    <v-row>
      <v-container>
        <v-row wrap>
          <v-col
            cols="12"
            class="headline"
            v-if="
              $route.params.eventType == 'delivery' &&
                $route.params.type == 'output' &&
                $route.params.step == 1
            "
            >PERSONA QUE TRANSPORTA EL EQUIPO</v-col
          >
          <v-col cols="12" class="headline" v-if="$route.params.step == 1"
            >PERSONA QUE ENTREGA EL EQUIPO</v-col
          >
          <v-col cols="12" class="headline" v-else
            >PERSONA QUE RECIBE EL EQUIPO</v-col
          >
          <v-col cols="12">
            <v-text-field
              outlined
              v-model="nameReceives"
              label="Persona que recibe"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pl-0 d-flex justify-space-between">
            <v-card
              max-width="100px"
              v-for="(n, index) in totalImages"
              :key="index"
              class="mx-2 card-style elevation-0"
            >
              <template v-if="items[index]" class="text-center">
                <v-icon
                  class="id__icon-delete"
                  color="accent"
                  dense
                  size="16"
                  @click.prevent="deleteImage(index)"
                  >fas fa-plus</v-icon
                >
                <img
                  :src="items[index]"
                  class="id__image px-0 py-0 mt-1"
                  alt="Image to upload"
                />
                <v-col
                  tag="div"
                  block
                  :class="items[index] ? 'green-background' : ''"
                  class="text-center id__image-text pa-0 white--text"
                  cols="12"
                  >{{ imagesTitles[index] }}</v-col
                >
              </template>
              <template v-else>
                <v-icon
                  class="pa-4"
                  color="gray"
                  @click.prevent="uploadImage(index)"
                  @onUpload="startImageResize"
                  @onComplete="endImageResize"
                  >fas fa-plus</v-icon
                >
                <template slot="loading">
                  <v-progress-circular
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </template>
                <v-col
                  tag="div"
                  block
                  class="text-center id__image-text pa-0 white--text"
                  cols="12"
                  >{{ imagesTitles[index] }}</v-col
                >
              </template>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-center">
            <canvas
              ref="canvas"
              id="canvas"
              class="text-center"
              v-on:mousedown="handleMouseDown"
              v-on:mouseup="handleMouseUp"
              v-on:mousemove="handleMouseMove"
              v-on:touchstart="handleMouseDown"
              v-on:touchmove="handleMouseMove"
              :width="sizeScreen"
              height="200px"
            ></canvas>
          </v-col>
          <v-col cols="5">
            <v-btn block color="accent" class="black--text" @click="clean"
              >Limpiar</v-btn
            >
          </v-col>
          <v-col cols="1"></v-col>
          <v-col cols="6">
            <v-btn block color="accent" class="black--text" @click="saveImg"
              >Siguiente</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <input
      v-show="false"
      ref="uploadSign"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadSign.files)"
    />
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { ResizeImage } from "@/services/ResizeImage";
export default {
  data() {
    return {
      frontOrBack: 0,
      totalImages: 2,
      imagesTitles: ["Foto ID frente", "Foto ID trasera"],
      items: [],
      clickedID: "",
      idItems: "995432",
      nameReceives: "",
      url: "",
      width: 320,
      lines: [],
      correctionX: 0,
      correctionY: 0,
      mouse: {
        current: {
          x: 0,
          y: 0
        },
        previous: {
          x: 0,
          y: 0
        },
        down: false
      },
      checkOrderImages: false
    };
  },
  beforeMount() {
    if (
      this.$route.params.eventType == "delivery" &&
      this.$route.params.type == "output"
    ) {
      this.totalImages = 4;
      this.imagesTitles.push("Orden firmada");
      this.imagesTitles.push("Contrato firmado");
      this.checkOrderImages = true;
    }
  },
  computed: {
    ...mapState("checklist", ["checklistRef"]),
    sizeScreen() {
      return screen.width * 0.825;
    },
    currentMouse: function() {
      var canvasRef = this.$refs.canvas;
      var rect = canvasRef.getBoundingClientRect();

      return {
        x: this.mouse.current.x - rect.left,
        y: this.mouse.current.y - rect.top
      };
    },
    isTransferRoute() {
      if (
        this.$route.name === "signChecklistTransportistTransfer" ||
        this.$route.name === "signChecklistReceptorTransfer"
      )
        return true;
      else return false;
    }
  },
  methods: {
    ...mapActions("checklist", ["saveSignChecklistReceptor"]),
    uploadImage(id) {
      this.clickedID = id;
      this.$refs.uploadSign.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        this.items[this.clickedID] = resizedImage;
        this.items.push(null);
        this.items.pop();
      }
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    },
    deleteImage(opc) {
      this.items[opc] = null;
      this.items.push(null);
      this.items.pop();
    },
    addImage(precessedImage) {
      const { output, id } = precessedImage;
      this.items[parseInt(id.split("-")[1])] = output.dataUrl;
      this.items.push(null);
      this.items.pop();
    },
    draw: function(event) {
      event.preventDefault();
      if (this.mouse.down) {
        var canvasRef = this.$refs.canvas;

        var canvas = canvasRef.getContext("2d");

        canvas.clearRect(0, 0, this.width, 200);
        let nuevaPositionX = 0;
        let nuevaPositionY = 0;
        if (event.changedTouches == undefined) {
          nuevaPositionX = event.layerX;
          nuevaPositionY = event.layerY;
        } else {
          nuevaPositionX = event.changedTouches[0].pageX - this.correctionX;
          nuevaPositionY = event.changedTouches[0].pageY - this.correctionY;
        }
        canvas.lineJoin = canvas.lineCap = "round";
        canvas.strokeStyle = "#000";
        canvas.lineWidth = 2;
        // Guarda la linea
        this.lines[this.lines.length - 1].push({
          x: nuevaPositionX,
          y: nuevaPositionY
        });
        // Redibuja todas las lines guardadas
        canvas.beginPath();
        this.lines.forEach(function(segment) {
          if (segment[0]) {
            canvas.moveTo(segment[0].x, segment[0].y);
            segment.forEach(function(point) {
              if (point.x && point.y) {
                canvas.lineTo(point.x, point.y);
              }
            });
          }
        });
        canvas.stroke();
      }
    },
    handleMouseDown: function(event) {
      this.mouse.down = true;
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY
      };
      this.lines.push([]);
      var canvasRef = this.$refs.canvas;
      var canvas = canvasRef.getContext("2d");
      var position = canvasRef.getBoundingClientRect();
      this.correctionX = position.x;
      this.correctionY = position.y;

      canvas.moveTo(this.currentMouse.x, this.currentMouse.y);
    },
    handleMouseUp: function() {
      this.mouse.down = false;
    },
    saveImg: async function() {
      if (
        this.nameReceives === "" ||
        !this.items[0] ||
        !this.items[1] ||
        this.lines.length < 1
      ) {
        errorMessage(
          (this.nameReceives.length > 3
            ? ""
            : "El nombre de la persona que recibe es obligatorio.\n") +
            (!this.items[0] ? "La foto frontal del id es obligatoria.\n" : "") +
            (!this.items[1] ? "La foto trasera del id es obligatoria.\n" : "") +
            (this.lines.length < 1 ? "La firma es obligatoria.\n" : "")
        );
      } else {
        if (this.checkOrderImages) {
          if (!this.items[2] || !this.items[3]) {
            errorMessage(
              (!this.items[2]
                ? "La foto de la orden firmada es obligatoria.\n"
                : "") +
                (!this.items[3]
                  ? "La foto del contrato firmado es obligatoria.\n"
                  : "")
            );
            return;
          }
        }
        try {
          var canvasRef = this.$refs.canvas;
          this.url = canvasRef.toDataURL();
          this.items.push(this.url);
          const checklistPath = this.$route.query.checklistPath;
          this.saveSignChecklistReceptor({
            images: this.items,
            nameReceives: this.nameReceives,
            step: this.$route.params.step,
            checkOrderImages: this.checkOrderImages,
            checklistPath
          });
          console.log(this.$route.params.step);
          if (this.$route.params.step == 1) {
            this.$router.push({
              name: this.isTransferRoute
                ? "signChecklistReceptorTransfer"
                : "signChecklistReceptor",
              params: {
                type: this.$route.params.type,
                step: 2
              },
              query: {
                checklistPath,
                path: this.$route.query.path,
                eventType: this.$route.params.eventType
              }
            });
          } else {
            console.log(this.$route.query.path);
            this.$router.push({ path: this.$route.query.path });
          }
        } catch (error) {
          console.log(error);
          errorMessage("Ocurrió un error inesperado.");
        } finally {
          this.nameReceives = "";
          this.items = [];
          this.clean();
        }
      }
    },
    clean: function() {
      this.lines = [];
      var canvasRef = this.$refs.canvas;

      var canvas = canvasRef.getContext("2d");

      canvas.clearRect(0, 0, this.width, 200);
      canvas.lineJoin = canvas.lineCap = "round";
      canvas.strokeStyle = "#000";
      canvas.lineWidth = 2;
      canvas.beginPath();
      this.lines.forEach(function(segment) {
        if (segment[0]) {
          canvas.moveTo(segment[0].x, segment[0].y);
          segment.forEach(function(point) {
            if (point.x && point.y) {
              canvas.lineTo(point.x, point.y);
            }
          });
        }
      });
      canvas.stroke();
    },
    handleMouseMove: function(event) {
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY
      };

      this.draw(event);
    }
  },
  ready: function() {
    var canvasRef = this.$refs.canvas;
    var canvas = canvasRef.getContext("2d");
    canvas.translate(0.5, 0.5);
    canvas.imageSmoothingEnabled = false;
    // this.draw();
  },
  props: ["type", "eventType", "step", "path"]
};
</script>

<style scoped>
canvas {
  background: white;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid #000;
}
.noImage {
  background: gray;
}
.image {
  background: #009d4f;
}
.card-style {
  text-align: center;
  border: 1px solid gray;
}
.col-style {
  float: right;
  margin-top: -19px;
}
.card-actions {
  text-align: center;
  justify-content: center;
  color: #fff;
}
.id__image {
  max-height: 50px;
  object-fit: contain;
  margin: 0;
  height: 100%;
  width: 100%;
}
.id__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  position: absolute;
  transform: rotate(45deg);
  z-index: 100;
}
.id__image-text {
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
  background-color: gray;
}
.green-background {
  background-color: #009d4f;
}
.icon-content {
  height: 55px;
}
</style>
